import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProductStrip } from './components/ProductStrip';
import { EnergyFeelCards } from './components/EnergyFeelCards';
import { CoffeeProblemSection } from './components/CoffeeProblemSection';
import { MadeForSection } from './components/MadeForSection';
import { UseCaseCards } from './components/UseCaseCards';
import { WhySmootherSection } from './components/WhySmootherSection';
import { TasteSection } from './components/TasteSection';
import { FirstDropCard } from './components/FirstDropCard';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
export function App() {
  return <div className="w-full min-h-screen bg-cream" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProductStrip data-id="element-2" />
      <EnergyFeelCards data-id="element-3" />
      <CoffeeProblemSection data-id="element-4" />
      <MadeForSection data-id="element-5" />
      <UseCaseCards data-id="element-6" />
      <WhySmootherSection data-id="element-7" />
      <TasteSection data-id="element-8" />
      <FirstDropCard data-id="element-9" />
      <FAQSection data-id="element-10" />
      <FinalCTASection data-id="element-11" />
    </div>;
}